import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../../../reducers/appstate'
import type {
  DispatchPropsType,
  PropsType
} from './LinkGoogle'
import LinkGoogle from './LinkGoogle'
import { PROVIDERS } from '../../../../../flowTypes'
import { toggleGoogleConnection } from '../../../../../actions/userActions'

const mapStateToProps = (state: AppStateType): PropsType => {
  return {
    isConnected: (state.user.providers || []).includes(PROVIDERS.google),
    linkAccountRequestInProgress: state.linkAccountRequestInProgress,
    isLoading: state.linkAccountRequestInProgress && (state.linkAccountRequestProvider === PROVIDERS.google)
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    toggleGoogleConnection: (isConnected: boolean): void => dispatch(toggleGoogleConnection(isConnected))
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkGoogle)
